import { createPortal } from "react-dom";
import { useContext, useRef, useState } from "react";
import "./EditRow.scss";
import { AppContext } from "../../Context/AppContext";
import { editRow } from "../CommonFunc";
import Notifications from "../../CommonComponents/Notifications/Notifications";
const columnNames = {
	ORDER_DATE: "Дата",
	TEST_NAME: "Вид анализа",
	UNITS: "Ед.изм.",
	NUMERIC_ENTRY: "Знач.",
	REFERENCE_LO: "Min",
	REFERENCE_HI: "Max",
};
function EditRow(props) {
	const [info, setInfo] = useState(undefined);
	const inputRef = useRef();
	const { theme } = useContext(AppContext);
	const [currentData, setCurrentData] = useState(props.data);
	const handleCreate = () => {
		editRow(currentData)
			.then((id) => {
				props.setUpdate(true);
				props.setEditable(false);
			})
			.catch((e) => {
				setInfo({ message: e.response.data });
			});
	};
	const onChange = (e, item) => {
		setCurrentData((prev) => ({ ...prev, [item]: e.target.value }));
	};
	return createPortal(
		<div
			className='edit-row-dialog-wrapper'
			color={theme.color}
			style={{
				fontSize: `${(18 / theme.scaleFactor) * theme.fontMultiplier}px`,
			}}
		>
			<Notifications info={info} setInfo={setInfo} />
			<div className='edit-row-dialog'>
				{Object.keys(currentData).map((item, i) => {
					if (item.toUpperCase() === "ORDER_DATE") {
						return (
							<div className='dialog-row'>
								<label>{columnNames[item]}</label>
								<input
									key={i}
									className='name-field'
									type='date'
									value={currentData[item].split("T")[0]}
									onChange={(e) => onChange(e, item)}
									// autoFocus
								/>
							</div>
						);
					} else if (
						item.toUpperCase() === "ORDER_DATE_D" ||
						item.toUpperCase() === "ORDER_DATE_T" ||
						item.toUpperCase() === "ARROW" ||
						item.toUpperCase() === "ORDER_CODE" ||
						item.toUpperCase() === "ID"
					) {
						return <></>;
					} else {
						return (
							<div className='dialog-row'>
								<label>{columnNames[item]}</label>
								<input
									key={i}
									className='name-field'
									type='text'
									value={currentData[item]}
									onChange={(e) => onChange(e, item)}
									// autoFocus
								/>
							</div>
						);
					}
				})}
				<div className='edit-row-dialog-actions'>
					<div className='create-button' onClick={handleCreate}>
						Сохранить
					</div>
					<div
						className='close-button'
						onClick={() => props.setEditable(false)}
					>
						Закрыть
					</div>
				</div>
			</div>
		</div>,
		document.getElementById("editRow")
	);
}

export default EditRow;
